import { BatchType } from 'types';

export const BATCH_TYPE_OPTIONS = [
  { value: BatchType.organization, label: 'Org' },
  { value: BatchType.vendor, label: 'Material Vendor' },
];

export const batchTypeLabel = (batchType: BatchType | ''): string =>
  BATCH_TYPE_OPTIONS.find((option) => option.value === batchType)?.label ?? '';
